namespace SPA
{
	export namespace Organization
	{
		export namespace gui
		{
			interface IInputUIDefinition
			{
				input:		ui.Form.BasicInputField;
				label?:		string;
				size:			ui.TwitterBootstrap3_3.IGridSize;
			}

			export class NewEmployeeEntry extends AbstractEntry
			{
				private Department: Wollmilch.DepartmentObject;

				public constructor( obj: Wollmilch.DepartmentObject, orga: OrgaTree )
				{
					super( orga );

					this.Department = obj;

					this.clearTitle();
					this.addTitle( 'Neuen Mitarbeiter anlegen' );
				}

				public rebuild( root?: ui.base.BaseHTMLElement<HTMLElement> | JQuery<HTMLElement> ): NewEmployeeEntry
				{
					super.rebuild( root );

					const form: ui.Form.Form = new ui.Form.Form(
						{
							action: 'organization/new/Employee',
							method: 'POST',
							notSwitchable: true,
							classes: [
								'form-horizontal'
							],
							css:
							{
								'display': 'flex',
								'flex-direction': 'column'
							},
							submit: ( _method: ui.Form.FormMethod, _url: string, parameter: ui.Form.IFormParameter ): void =>
							{
								new Wollmilch.AJAX(
									{
										method: _method,
										url: _url,
										data: parameter,
										on:
										{
											success: ( jsonText: string ): void =>
											{
												const result = Wollmilch.jsonize( jsonText );

												if ( result === null )
												{
													app.addNotify(
														{
															body: [
																'Es ist ein Fehler bei der Verarbeitung der Anfrageantwort aufgetreten,' +
																' bitte versuchen Sie es später erneut!'
															],
															title: [ 'Schwerwiegender Fehler' ],
															context: 'danger',
															timeout: Number(app.getConfigValue("ToastTimeout"))
														}
													);

													return;
												}

												if ( !result.success )
												{
													app.addNotify(
														{
															body: [
																'Die Anfrage ist fehlgeschlagen, bitte versuchen Sie es erneut.'
															],
															title: [ 'Anfragefehler' ],
															context: 'danger',
															timeout: Number(app.getConfigValue("ToastTimeout"))
														}
													);

													return;
												}

												app.addNotify(
													{
														body: [ 'Mitarbeiter erfolgreich angelegt.' ],
														title: [ 'Erfolg!' ],
														context: "success",
														timeout: Number(app.getConfigValue("ToastTimeout"))
													}
												);

												const data = result.data as Wollmilch.EmployeeObject;

												new Wollmilch.AJAX(
													{
														method: 'POST',
														url: 'organization/link/' + this.Department.ID + '/' + data.ID,
														data:
														{
															function: 'PartOf'
														},
														on:
														{
															success: () =>
															{
																const link = Wollmilch.jsonize( jsonText );

																if ( link === null || !link.success )
																{
																	app.addNotify(
																		{
																			body: [
																				'Mitarbeiter konnte nicht mit der Abteilung ' + this.Department.Name + ' verbunden werden.'
																			],
																			title: [ 'Schwerwiegender Fehler' ],
																			context: 'danger',
																			timeout: Number(app.getConfigValue("ToastTimeout"))
																		}
																	);

																	return;
																}

																app.addNotify(
																	{
																		context: "success",
																		body: [ 'Mitarbeiter erfolgreich mit der Abteilung ' + this.Department.Name + ' verbunden.' ],
																		timeout: Number(app.getConfigValue("ToastTimeout")),
																		title: [ 'Erfolg!' ]
																	}
																);
																$('html').trigger('reloadOrgaTree');
															}
														}
													},
													Wollmilch.AJAXCallbase_e.APIV1
												).send();
											}
										}
									},
									Wollmilch.AJAXCallbase_e.APIV1
								).send();
							}
						}
					);

					form.rebuild( this );

					form.append(
						ui.$$.p()
							.text( 'Bitte füllen Sie alle Felder aus, welche mit einem Sternchen (*) gekennzeichnet sind' )
							.addClass( 'form-required text-danger small-caps' )
					);

					this.buildBasicInfo( form );

					const l_BtnBar = new ui.base.BaseHTMLElement( 'div' );

					new ui.base.Button(
						$('<i class="fa fa-save"></i> <span>Speichern</span>'),
						{
							context: 'success',
							attr:
							{
								type: 'submit'
							},
							id: 'newEmpButton'
						}
					).rebuild( l_BtnBar );

					form.append( l_BtnBar );

					// form.Initialize();

					return this;
				}

				private buildBasicInfo( _form: ui.Form.Form ): void
				{
					const basics: ui.base.BaseHTMLElement = new ui.base.BaseHTMLElement( 'div' );

					basics.css( { 'flex-grow': '1' } );

					basics.appendTo( _form );

					basics.append(
						ui.$$.h( 4, 'Mitarbeiter-Daten' )
					);

					this.AddInput(
						basics,
						_form,
						[
							{
								size: {
									xs: 12,
									sm: 12,
									md: 8,
									lg: 8
								},
								input: new ui.Form.TextInput(
									null,
									{
										name: 'StaffNumber',
										noautocomplete: true,
										placeholder: 'Interne Mitarbeiternummer',
										required: false
									}
								),
								label: 'Mitarbeiternummer'
							}
						]
					);

					this.AddInput(
						basics,
						_form,
						[
							{
								size: {
									xs: 12,
									sm: 12,
									md: 8,
									lg: 8
								},
								input: new ui.Form.TextInput(
									null,
									{
										name: 'Name',
										noautocomplete: true,
										placeholder: 'Nachname des neuen Mitarbeiters',
										required: true
									}
								),
								label: 'Nachname*'
							}
						]
					);

					this.AddInput(
						basics,
						_form,
						[
							{
								size: {
									xs: 12,
									sm: 12,
									md: 8,
									lg: 8
								},
								input: new ui.Form.TextInput(
									null,
									{
										name: 'Surname',
										noautocomplete: true,
										placeholder: 'Vorname des neuen Mitarbeiters',
										required: false
									}
								),
								label: 'Vorname*'
							}
						]
					);

					this.AddInput(
						basics,
						_form,
						[
							{
								size: {
									lg: 8,
									md: 8,
									sm: 12,
									xs: 12
								},
								label: 'Geschlecht*',
								input: new ui.Form.RadioGroup(
									{
										radioButtons: [
											{
												title: 'Männlich',
												value: 'm'
											},
											{
												title: 'Weiblich',
												value: 'w'
											}
										],
										name: 'Gender'
									}
								)
							}
						]
					);

					this.AddInput(
						basics,
						_form,
						[
							{
								label: 'Geburtstag*',
								size:
								{
									xs: 12,
									sm: 12,
									md: 8,
									lg: 8
								},
								input: new ui.Form.DateInput(
									new Date(),
									'Y-m-d',
									{
										required: true,
										name: 'Birthday',
										aria:
										{
											label: 'Geburtstag des neuen Mitarbeiter'
										}
									}
								)
							}
						]
					);
				}
			}
		}
	}
}
